/* eslint-disable react/prop-types */
import React from 'react';
import axios from 'axios';
import AddButtonCell from '../components/AddButtonCell';
import DefaultCell from 'layouts/pages/finantial/invoice-list/components/DefaultCell';

const fetchData = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/finance/consolidated/`);
    const data = Array.isArray(response.data) ? response.data : [];
    console.log(data);
    const consolidatedArray = Array.isArray(data)
      ? data
      : (data && data.rows ? data.rows : []);

    // Ordena el array de datos por la propiedad 'creation' (del más nuevo al más antiguo)
    consolidatedArray.sort((a, b) => new Date(b.creation) - new Date(a.creation));

    const rows = consolidatedArray.map(item => ({
      addButton: <AddButtonCell consolidatedNumber={item.master_number} />,
      consolidatedNumber: item.master_number,
      costPP: item.costpp,
      costCC: item.costcc,
      incomePP: item.incpp,
      incomeCC: item.inccc,
      grossProfit: item.gross_profit,
      agentProfit: item.agent_profit,
      yourProfit: item.your_profit,
      youOweAgent: item.owe_agent,
    }));

    return {
      columns: [
        {
          Header: '',
          accessor: 'addButton',
          Cell: ({ value }) => value,
        },
        {
          Header: '# Consolidado',
          accessor: 'consolidatedNumber',
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
        {
          Header: 'Cost PP',
          accessor: 'costPP',
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
        {
          Header: 'Cost CC',
          accessor: 'costCC',
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
        {
          Header: 'Income PP',
          accessor: 'incomePP',
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
        {
          Header: 'Income CC',
          accessor: 'incomeCC',
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
        {
          Header: 'Gross Profit',
          accessor: 'grossProfit',
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
        {
          Header: 'Agent Profit',
          accessor: 'agentProfit',
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
        {
          Header: 'Your Profit',
          accessor: 'yourProfit',
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
        {
          Header: 'You owe Agent',
          accessor: 'youOweAgent',
          Cell: ({ value }) => <DefaultCell value={value} />,
        },
      ],
      rows,
    };
  } catch (error) {
    console.error('Error fetching consolidated data:', error);
    return { columns: [], rows: [] };
  }
};

export default fetchData;
